<template>
    <views class="gift-detail">
        <nav-bar
            title="奖品详情"
            fixed
            @click-left="onClickLeft">
        </nav-bar>
        <views v-if="detail.gift_name" class="gift-detail-content">
            <views class="head">
                <views class="title">抽奖获得{{ detail.gift_name }}</views>
                <views v-if="detail.gift_amount > 0" class="count">{{ detail.gift_amount }}<views class="unit">元</views></views>
            </views>
            <views class="content">
                <views class="content-list">
                    <views class="content-list-l">中奖时间</views>
                    <views class="content-list-r">{{ detail.created_at }}</views>
                </views>
                <views class="content-list">
                    <views class="content-list-l">产品名称</views>
                    <views class="content-list-r">{{ detail.product_name }}</views>
                </views>
                <views class="content-list">
                    <views class="content-list-l">品牌</views>
                    <views class="content-list-r">{{ detail.brand }}</views>
                </views>
                <views class="content-list">
                    <views class="content-list-l">暗码</views>
                    <views class="content-list-r">{{ detail.code_secret }}</views>
                </views>
            </views>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import tools from '@/mixins/tools'
import api from '@/utils/api'
export default {
    components: {
        NavBar
    },
    mixins: [tools],
    props: {
        color: {
            type: String,
            default: '#1989fa'
        }
    },
    data() {
        return {
            detail: {}
        }
    },
    computed: {
        id() {
            return this.$route.query.id
        }
    },
    created() {
        this.getDetail()
    },
    methods: {
        onClickLeft() {
            this.back()
        },
        getDetail() {
            api.getPrizeDetail({ id: this.id }).then((res) => {
                if (res.data) {
                    this.detail = res.data
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
